<template>
	<div class="component social-share">
		<button
			class="uk-button uk-button-small uk-button-primary"
			:class="[platform, {'uk-margin-xsmall-right': !isLastPlatform(index)}]"
			v-for="(platform, index) in platforms"
			:key="platform"
			@click="share(platform)"
		>
			<span :uk-icon="'icon: ' + getIconName(platform)"></span>
		</button>
	</div>
</template>

<script>
export default {
	name: 'SocialShare',
	props: {
		url: {
			type: String,
			default: () => window.location.href,
		},
		title: {
			type: String,
			default: '',
		},
		platforms: {
			type: Array,
			default: () => [],
		},
	},
	methods: {
		share(platform) {
			
			const component = this;
			const encodedUrl = encodeURIComponent(this.url);
			const encodedTitle = encodeURIComponent(this.title);
			let shareUrl = '';

			switch (platform) {
				case 'facebook':
					shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
					break;
				case 'x':
					shareUrl = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`;
					break;
				case 'linkedin':
					shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedTitle}`;
					break;
				case 'whatsapp':
					shareUrl = `https://api.whatsapp.com/send?text=${encodedTitle} ${encodedUrl}`;
					break;
				case 'link': 
					component.copyToClipboard();
					return;
				case 'email':
					shareUrl = `mailto:?subject=${encodedTitle}&body=${encodedUrl}`;
					window.location.href = shareUrl;
					return;
				default:
					console.error('Unsupported platform');
					return;
			}

			window.open(shareUrl, '_blank', 'noopener,noreferrer');
		},
		getIconName(platform) {
			// Map platform to icon name here
			const platformIcons = {
				facebook: 'facebook',
				x: 'x', // Assuming 'x' needs a placeholder icon
				linkedin: 'linkedin',
				whatsapp: 'whatsapp',
				email: 'mail',
				link: 'link'
			};
			return platformIcons[platform] || 'question'; // Default icon if not found
		},		
		isLastPlatform(index) {
			// Check if the current platform is the last in the array
			return index === this.platforms.length - 1;
		},
		async copyToClipboard() {
			try {
				await navigator.clipboard.writeText(this.url);
				UIkit.modal.alert('URL naar clipboard gekopieerd')
			} catch (err) {
				console.error('Failed to copy: ', err);
			}
		},
	},
};
</script>

<style scoped>
.component.social-share {
	display: inline-block;
}
.component.social-share .uk-button {
	color: white;
}
.component.social-share .uk-button.whatsapp {
	background: #25D366;
}
.component.social-share .uk-button.facebook {
	background: #1877F2;
}
.component.social-share .uk-button.x {
	background: #070707;
}
</style>
